export default __webpack_public_path__ + "static/media/csv.f2ac505f.svg";